import React from 'react';
import axios from 'axios';

import { connect } from 'react-redux';

import { actions } from './';

import SelectField from '../../../../../shared/form-elements/select/field';

function Geos({ className, affiliate, disabled, updateGeos, locationsLookups }) {
	return (
		<div className={className}>
			<SelectField
				placeholder='Working GEOs'
				name='geos'
				disabled={disabled}
				options={locationsLookups}
				multi
				value={affiliate.geos}
				meta={{}}
				onChange={async (values) => {
					await axios({
						method: 'PUT',
						url: `v2/affiliates/${affiliate.id}/geos`,
						data: {
							geos: values.map((v) => v.value)
						}
					});

					updateGeos(values);
				}}
			/>
		</div>
	);
}

export default connect(undefined, actions)(Geos);



// WEBPACK FOOTER //
// ./frontend/admin-dashboard/src/modules/affiliates/components/profile/header/geos/main.js